module.exports = __webpack_public_path__ + "static/media/croppedMug.c8342a5e.png";